import { FC } from "react";
import { PageHeader } from "../../components/PageHeader";
import { Changelog } from "../../modules/Changelog";

export const ChangelogPage: FC = () => {
  return (
    <div>
      <PageHeader
        header="Changelog"
        description="Enter changelog information for upcoming package"
      />
      <Changelog />
    </div>
  );
};
